export const EMAIL_INPUT_PATTERN = '[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}';

const EMAIL_PATTERN = new RegExp(`^${EMAIL_INPUT_PATTERN}$`, 'i');
const CNPJ_PATTERN = /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/;
const PHONE_PATTERN = /^\(\d{2}\)\d{4,5}-\d{4}$/;

export const isValidEmail = (value: string) => EMAIL_PATTERN.test(value.trim());

export const formatCnpj = (value: string) => {
    const sanitized = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    const registration = sanitized.slice(0, 12);
    const checkDigits = sanitized.slice(12).replace(/\D/g, '').slice(0, 2);
    const characters = `${registration}${checkDigits}`;

    if (characters.length <= 2) return characters;

    let formatted = `${characters.slice(0, 2)}.${characters.slice(2, 5)}`;
    if (characters.length > 5) formatted += `.${characters.slice(5, 8)}`;
    if (characters.length > 8) formatted += `/${characters.slice(8, 12)}`;
    if (characters.length > 12) formatted += `-${characters.slice(12, 14)}`;
    return formatted;
};

export const isValidCnpjFormat = (value: string) => CNPJ_PATTERN.test(value.trim().toUpperCase());

export const formatPhone = (value: string) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (!digits) return '';
    if (digits.length <= 2) return `(${digits}`;

    const areaCode = digits.slice(0, 2);
    const number = digits.slice(2);
    const prefixLength = digits.length === 11 ? 5 : 4;
    const prefix = number.slice(0, prefixLength);
    const suffix = number.slice(prefixLength, prefixLength + 4);

    return `(${areaCode})${prefix}${suffix ? `-${suffix}` : ''}`;
};

export const isValidPhoneFormat = (value: string) => PHONE_PATTERN.test(value.trim());
